import { render, staticRenderFns } from "./listCatalogs.vue?vue&type=template&id=510458f3&"
import script from "./listCatalogs.vue?vue&type=script&lang=js&"
export * from "./listCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports